"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledModal = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var DpModal_1 = require("../Modal/DpModal");
exports.StyledModal = (0, styled_components_1.default)(DpModal_1.DpModal)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .modal-header {\n    border-bottom: none;\n\n    h1 {\n      margin: 0;\n    }\n  }\n\n  .modal-body {\n    border-radius: ", ";\n    padding: ", ";\n\n    table {\n      width: 100%;\n      border: 2px solid ", ";\n      box-shadow: -1px 1px ", ";\n\n      /* Overriding bootstrap css */\n      > :not(caption) > * > * {\n        background-color: unset;\n        box-shadow: unset;\n      }\n\n      thead {\n        background-color: ", ";\n\n        th {\n          padding: ", ";\n          box-shadow: none;\n          background-color: inherit;\n\n          span {\n            color: ", ";\n            font-size: ", ";\n          }\n        }\n      }\n\n      tbody {\n        .shadow-hover-md:hover {\n          box-shadow: none;\n        }\n\n        tr:nth-child(even) {\n          background-color: ", ";\n        }\n\n        td {\n          color: ", ";\n          padding: 0.75rem;\n        }\n      }\n    }\n  }\n"], ["\n  .modal-header {\n    border-bottom: none;\n\n    h1 {\n      margin: 0;\n    }\n  }\n\n  .modal-body {\n    border-radius: ", ";\n    padding: ", ";\n\n    table {\n      width: 100%;\n      border: 2px solid ", ";\n      box-shadow: -1px 1px ", ";\n\n      /* Overriding bootstrap css */\n      > :not(caption) > * > * {\n        background-color: unset;\n        box-shadow: unset;\n      }\n\n      thead {\n        background-color: ", ";\n\n        th {\n          padding: ", ";\n          box-shadow: none;\n          background-color: inherit;\n\n          span {\n            color: ", ";\n            font-size: ", ";\n          }\n        }\n      }\n\n      tbody {\n        .shadow-hover-md:hover {\n          box-shadow: none;\n        }\n\n        tr:nth-child(even) {\n          background-color: ", ";\n        }\n\n        td {\n          color: ", ";\n          padding: 0.75rem;\n        }\n      }\n    }\n  }\n"])), function (_a) {
    var Dimensions = _a.theme.Dimensions;
    return Dimensions.Borders.Radiuses.strong;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return "".concat(Spacing.x1, " ").concat(Spacing.x4, " ").concat(Spacing.x5, " ").concat(Spacing.x4);
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.primary;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Shadows.light;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.primary;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return "".concat(Spacing.x1, " ").concat(Spacing.x2);
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.white;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.sm;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Backgrounds.subtle;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Typography.primary;
});
var templateObject_1;
